import {guidGenerator} from "./lib/helpers/guid";
import PeriodicExecuter from "./lib/helpers/periodic_executer";
import {allowBodyScroll, prohibitBodyScroll} from "./lib/helpers/body_scrolling";

// All StoneArrow application JS should be within the `StoneArrow` namespace
if (!window.StoneArrow) window.StoneArrow = {};
if (!window.StoneArrow.helpers) window.StoneArrow.helpers = {};

window.StoneArrow.helpers.guidGenerator = guidGenerator;
window.StoneArrow.helpers.PeriodicExecutor = PeriodicExecuter;
window.StoneArrow.helpers.allowBodyScroll = allowBodyScroll;
window.StoneArrow.helpers.prohibitBodyScroll = prohibitBodyScroll;

import {CurrencyUpdater} from './lib/services/currency_updater'

new CurrencyUpdater();

import ReviewsReader from './lib/services/reviews_reader';
import {ReviewsSummary, ReviewsSummaryConfig} from './lib/components/reviews_summary';

window.StoneArrow.ReviewsReader = ReviewsReader;
window.addEventListener('DOMContentLoaded', () => {
    const reviewsReader = new window.StoneArrow.ReviewsReader({sourceId: 'product-reviews'});
    reviewsReader.getData().then((reviewsData) => {
        document.querySelectorAll(ReviewsSummaryConfig.selector).forEach((element) => {
            if (ReviewsSummary.isElementComponentized(element, ReviewsSummaryConfig.signature)) return;
            new ReviewsSummary(element, reviewsData);
        });
    }).catch((error) => {
        console.warn(error);
    });
});

import MicroModal from 'micromodal';

window.StoneArrow.MicroModal = MicroModal;
window.addEventListener('DOMContentLoaded', (event) => {
    window.StoneArrow.MicroModal.init({
        openClass: 'micromodal-slide--open',
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        disableFocus: true
    });
});

import {Navbar} from './lib/components/navbar/index';

window.addEventListener('DOMContentLoaded', Navbar.applyToAll);

import NavMenu from './lib/components/nav_menu/index';

window.StoneArrow.NavMenu = NavMenu;
window.dispatchEvent(new Event('StoneArrow:NavMenu::Loaded'));

import {ProductTitle} from "./lib/components/product_title";

window.StoneArrow.ProductTitle = ProductTitle;
window.addEventListener('DOMContentLoaded', ProductTitle.applyToAll);

import {Collapser} from "./lib/components/collapser";

window.addEventListener('DOMContentLoaded', Collapser.applyToAll);

import {EmailSignup} from './lib/components/email_signup/index';

window.StoneArrow.EmailSignup = EmailSignup;
window.dispatchEvent(new Event('StoneArrow:EmailSignup::Loaded'));

import {CurrencySwitcher} from "./lib/components/currency_switcher";

window.addEventListener('DOMContentLoaded', CurrencySwitcher.applyToAll);

import Splide from '@splidejs/splide';

window.StoneArrow.Splide = Splide;

import GoCart from './lib/gocart';

document.addEventListener('DOMContentLoaded', function () {
    new GoCart({
        cartMode: 'drawer', //drawer or mini-cart
        drawerDirection: 'right', //cart drawer from left or right
        displayModal: false, //display success modal when adding product to cart
        moneyFormat: '<span class="money">${{amount}}</span>', //template for money format when displaying money
        cartTitle: 'basket',
    });
});

// CartCounter will monitor the navbar shopping cart quantity counter and render it when it changes.
import {CartCounter} from './lib/components/cart_counter/index';

window.addEventListener('DOMContentLoaded', CartCounter.applyToAll);

import {PageNav} from './lib/components/page_nav/index';

window.addEventListener('DOMContentLoaded', PageNav.applyToAll);

import {PageTopper} from './lib/components/page_topper/index';

window.addEventListener('DOMContentLoaded', PageTopper.applyToAll);

import {Breakpointer} from './lib/components/breakpointer/index';

window.addEventListener('DOMContentLoaded', Breakpointer.applyToAll);

import {RewardsNavbarItem} from "./lib/components/rewards_navbar_item";
import {RewardsLauncherToggler} from './lib/components/rewards_launcher_toggler/index';
import {StampedIoConfig} from "./lib/stamped_io/stamped_io_config";

document.addEventListener(StampedIoConfig.launcherLoadedEventName, function (e) {
    if (window.StampedFn && window.StampedFn.toggleRewardsModal) {
        RewardsLauncherToggler.applyToAll(window.StampedFn.toggleRewardsModal);
        RewardsNavbarItem.applyToAll(window.StampedFn.toggleRewardsModal)
    }
});

// CartCounter will monitor the navbar shopping cart quantity counter and render it when it changes.
import {RewardsCounter} from './lib/components/rewards_counter/index';

window.addEventListener('DOMContentLoaded', RewardsCounter.applyToAll);


//
import {ProductItem} from './lib/components/product_item/index';

window.addEventListener('DOMContentLoaded', ProductItem.applyToAll);

//
import {ProductCollection} from './lib/components/product_collection/index';

window.addEventListener('DOMContentLoaded', ProductCollection.applyToAll);

// Responsive images will swap out the img src depending on it's current dimensions.
import {ResponsiveImage} from './lib/components/responsive_image/index';

window.addEventListener('DOMContentLoaded', ResponsiveImage.applyToAll);

// Orientator will apply a HTML class modifier depending on the element's orientation.
import {Orientator} from './lib/components/orientator/orientator';
window.addEventListener('DOMContentLoaded', Orientator.applyToAll);


import {ComponentWatcher} from "./lib/services/component_watcher";

window.addEventListener('DOMContentLoaded', () => {

    // The following mutation observer is used to construct new components whenever
    // the DOM is modified (in case new elements are added but their component is not applied).
    const constructComponentsCallback = function (mutations, observer) {
        ProductTitle.applyToAll();
        Collapser.applyToAll();
        Breakpointer.applyToAll();
        ProductItem.applyToAll();
        ResponsiveImage.applyToAll();
    }

    new ComponentWatcher(constructComponentsCallback);
});


// Everything is loaded!
window.dispatchEvent(new Event('StoneArrow:Application::Loaded'));

// Remove the annoying Shopify #preview-bar-iframe
window.setTimeout(() => {
    let previewBar = document.querySelector('html[env=staging] #preview-bar-iframe')
    if (previewBar) {
        previewBar.style['display'] = 'none';
        document.documentElement.removeAttribute('style');
    }
}, 4000);

